<template>
  <div>
    <app-header title="Plans"/>
    <b-card class="card-container page height-full">
      <spinner v-if="isLoading == true"></spinner>
      <b-col md="6" offset="3" v-if="isLoading == false">
        <b-col md="12 text-center">
          <h2>How many credits do you need?</h2>
          <p>Each SMS message is billed as 1 credit per message.</p>
          <p>Pay annually and save 25%!</p>
          <b-form-checkbox 
            v-model="annualSelected" 
            name="check-button" 
            class="check-btn" 
            switch size="lg"
            @change="switchChanged"></b-form-checkbox><br />
        </b-col>
        <div class="text-center">
          <b-button-group style="">
            <div v-for="plan in displayedPlans">
              <b-btn 
                v-if="isActivePlan(plan)"
                variant="primary" 
                class="btn-plan"
                @click="displayPlan(plan)">
                <b v-if="annualSelected == true">{{formatNumber(Number(plan.metadata.credits) * 100 / 12)}}</b>
                <b v-else>{{formatNumber(Number(plan.metadata.credits) * 100)}}</b>
              </b-btn>
              <b-btn 
                v-else
                variant="outline-primary" 
                class="btn-plan"
                @click="displayPlan(plan)">
                <b v-if="annualSelected == true">{{formatNumber(Number(plan.metadata.credits) * 100 / 12)}}</b>
                <b v-else>{{formatNumber(Number(plan.metadata.credits) * 100)}}</b>
              </b-btn>
            </div>
          </b-button-group>
        </div>
        <b-col md="12" class="plan-info-container">
          <div v-if="showCurrentPlan">
            <h3>{{formattedName()}}</h3>
            <p class="pricing">{{formattedPrice()}}</p>
            <p class="text-muted pricing-description">{{formattedPriceDescription()}}</p>
            <div v-if="annualSelected == true">  <b-badge pill variant="success">Save 25%!</b-badge></div>
            <ul>
              <li><b-icon-check class="check-icon" />1 credit per message sent</li>
              <li><b-icon-check class="check-icon" />Unlimited incoming messages</li>
              <li><b-icon-check class="check-icon" />Messages roll over</li>
              <li><b-icon-check class="check-icon" />Send message campaigns</li>
              <li><b-icon-check class="check-icon" />Enhanced analytics</li>
            </ul>
            <b-button type="submit" class="btn-upgrade" variant="primary" @click="checkout"><strong>Upgrade</strong></b-button>
          </div>
        </b-col>
      </b-col>
    </b-card>
  </div>
</template>

<script>
  import axios from "axios";
  import Constants from "../../Constants"
  import Spinner from '../common/Spinner'

  export default {
    name: "PlansList",
    components: {
      Spinner
    },
    data: () => {
      return {
        isLoading: false,
        plans: [],
        currentPlan: null,
        monthlyPlans: [],
        annualPlans: [],
        annualSelected: true
      }
    },
    computed: {
      showCurrentPlan: function() {
        return this.currentPlan != null
      },
      displayedPlans: function() {
        var plans = []
        if (this.annualSelected) {
          plans = this.annualPlans
        } else {
          plans = this.monthlyPlans
        }
        return plans.sort(function(a, b) {
          const a_creds = Number(a.metadata.credits)
          const b_creds = Number(b.metadata.credits)
          if (a_creds < b_creds) {
            return -1
          }

          if (b_creds > a_creds) {
            return 1
          }

          return 0
        })
      }
    },  
    methods: {
      checkout() {
        axios
          .get(Constants.API_URL + "/stripe/checkouts?planId=" + this.currentPlan.id)
          .then(response => {
            console.log(response);
            return this.redirect(response.data.id)
          }).catch((err) => {
            swal("", err.message, "error").show()
          })
      },
      switchChanged: function(el) {
        this.annualSelected = el
        this.currentPlan = this.displayedPlans[0]
      },
      redirect(sessionId) {
        var stripe = Stripe(Constants.STRIPE_KEY);
        stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          console.log(result.error.message)
        });
      },
      getPlans() {
        this.isLoading = true

        // Do not show paused plan. 
        axios.get(Constants.API_URL + "/plans")
          .then((response) => {
            this.plans = response.data.data
            this.plans.forEach(plan => {
              console.log(plan)
              if (Number(plan.metadata.credits) > 0 && plan.interval == 'month') {
                this.monthlyPlans.push(plan)
              }
              this.monthlyPlans = this.monthlyPlans

              if (Number(plan.metadata.credits) > 0 && plan.interval == 'year') {
                this.annualPlans.push(plan)
              }
              this.annualPlans = this.annualPlans
            })
            console.log(response.data.data)
            this.currentPlan = this.displayedPlans[0]
          }).catch((err) => {
            console.log(err)
          }).then(() => {
            this.isLoading = false
          })

        // axios.get(Constants.API_URL + "/plans")
        //   .then(response => {
        //     console.log(response)
        //   }).catch(err => {
        //     console.log(err)
        //   }).then(() => {
        //     this.isLoading = false
        //   })
      },
      formattedName: function() {
        if (this.currentPlan.interval == 'year') {
          return this.formatNumber(Number(this.currentPlan.metadata.credits) * 100 / 12) + " Credits"  
        } else {
          return this.formatNumber(Number(this.currentPlan.metadata.credits) * 100) + " Credits"  
        }
      },
      formattedPrice: function() {
        if (this.currentPlan.interval == 'year') {
          return "$" + this.formatNumber(this.currentPlan.amount / 12)
        } else {
          return "$" + this.formatNumber(this.currentPlan.amount)
        }
      },
      formattedPriceDescription: function() {
        if (this.currentPlan.interval == 'year') {
          return "per month (billed annually)"
        } else {
          return "per month"
        }
      },
      formatNumber: function(amount, decimalCount = 0, decimal = ".", thousands = ",") {
        var amount = amount / 100
        try {
          decimalCount = Math.abs(decimalCount);
          decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

          const negativeSign = amount < 0 ? "-" : "";

          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;

          return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
          console.log(e)
          return amount
        }
      },
      isActivePlan: function(plan) {
        console.log("Active plan")
        console.log(plan)
        return plan.id == this.currentPlan.id
      },
      displayPlan: function(plan) {
        this.currentPlan = plan
      } 
    },
    mounted() {
      this.getPlans()
    }
  }
</script>

<style scoped>
  .plan-content {
    height: 300px;
  }

  .plan { 
    margin-left: 50px;
    margin-top: 100px;
    min-height: 400px;
  }

  .md-card-actions {
    justify-content: center;
    padding: 0;
  }

  .title {
    margin-top: 25px;
  }

  .btn-upgrade {
    width: 200px;
    margin-bottom: 0px;
    color: white;
    text-align: center;
    margin-top: 24px;
  }

  .btn-plan {
    margin-left: 4px;
    margin-right: 4px;
    clear: both;
  }

  .plan-info-container {
    border: 1px solid #d7d7d7;
    margin-top: 24px;
    padding: 48px;
    border-radius: 8px;
    text-align: center;
  }

  .pricing {
    font-size: 48px;
    font-weight: bold;
    color: black;
    margin-top: 24px;
  }

  .pricing-description {
    margin-top: -16px;
    margin-bottom: 32px;
  }

  .check-icon {
    color: #5cb85c; 
    font-size: 18px;
    margin-right: 8px;
  }
  
  .card-container {
    padding-top: 5%;
    padding-bottom: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/plans/PlansList.vue